import {Inject, Injectable} from '@angular/core';
import {Socket, SocketIoConfig} from 'ngx-socket-io';
import {environment} from '../../environments/environment';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class SocketIoService {

  constructor(private socket: Socket, @Inject(LOCAL_STORAGE) private storage: StorageService) {
    const userDetails = this.storage.get('gs-loggedInUser');
    const userData = this.storage.get('gs-loggedInUserData');
    let config: SocketIoConfig = {
      url: environment.SOCKET_SERVER_URL,
      options: {
        autoConnect: true, reconnection: true,
        query: {
          token: userDetails.authCode,
          userId: userData.userId, type: 'LISTENER'
        }
      }
    };
    this.socket = new Socket(config);
  }

  joinRoom(vehicleId) {
    this.socket.emit('join_room_request', {room: vehicleId});
  }

  onMessageReceive() {
    return this.socket.fromEvent('message');
  }

  sendMessage(event: string, message) {
    this.socket.emit(event, message);
  }

  leaveRoom(userVehicleId: any) {
    this.socket.emit('exit_room_request', {room: userVehicleId});

  }
}
